module.exports = __webpack_public_path__ + "img/Whatsapp.c48efe0d.svg";